export default "__VITE_ASSET__CtZsK_kB__"